import { render, staticRenderFns } from "./MiniFateFortunePanel.vue?vue&type=template&id=3e1664e6&"
import script from "./MiniFateFortunePanel.vue?vue&type=script&lang=js&"
export * from "./MiniFateFortunePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports